export default "__VITE_ASSET__00dc6cce__"